import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

/**
 * Opens an external link in a native-safe way.
 * - Uses Capacitor's Browser plugin in native apps for http/https
 * - Uses Capacitor's App plugin for custom URL schemes
 * - Uses window.open in web/PWA
 * Returns a promise that resolves when the link is opened, or rejects if there's an error
 */
export const openExternalLink = async (url: string): Promise<void> => {
  try {
    if (Capacitor.isNativePlatform()) {
      // Check if this is a special URL scheme (not http/https)
      if (url.startsWith("vnd.") || url.startsWith("intent:")) {
        // Use App plugin for custom URL schemes - in Capacitor v5+ it's just called openUrl
        await Browser.open({ url });
      } else {
        // Use Browser plugin for regular web URLs
        await Browser.open({ url });
      }
    } else {
      // window.open() may return null due to popup blockers or browser security
      // but the tab/window may still open successfully, so we don't throw an error
      window.open(url, "_blank", "noopener,noreferrer");
    }
  } catch (error) {
    console.error("Error opening external link:", error);
    throw error; // Re-throw to allow the caller to catch it
  }
};
